import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('IssueFormCategoryController', IssueFormCategoryController);

    function IssueFormCategoryController($scope, IMieszkaniecFactory) {
        var vm = this;

        init();

        function init() {
            vm.dataFromBackend = [];
        }

        function downloadCategories(client_id) {
            IMieszkaniecFactory.fetchCategories(client_id).then(function (
                response
            ) {
                vm.dataFromBackend = response.data;
            });
        }

        $scope.$watch(
            function () {
                return vm.clientId;
            },
            function () {
                if (vm.clientId) {
                    downloadCategories(vm.clientId);
                } else {
                    vm.dataFromBackend = [];
                }
            }
        );
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/fragments/category/issue_form_category.controller.ts